import {Component, Output, EventEmitter} from '@angular/core';
import {Notify} from "../../services/Notify";
import {Locations} from "../../services/Locations";
import {FileUploadButtonDialog} from "../file-upload-button/FileUploadDialogCmp";

@Component({
  selector: 'sanofi-upload-results',
  templateUrl: './sanofi.html',
})
export class SanofiUploadResultsCmp {
  @Output() update = new EventEmitter();
  public uploading = false;

  constructor(public locations:Locations) {}

  addResultsFile(files) {
    if (!files || !files[0]) {
      return;
    }
    let fileData = files[0];
    this.uploading = true;
    this.locations.uploadSanofiResultsFile(fileData).subscribe((response)=> {
      let responseText = '';
      if (response && response.currentTarget && response.currentTarget.responseText) {
        responseText = response.currentTarget.responseText;
      }
      this.uploading = false;
      this.update.emit(responseText);
      let n = new Notify();
      n.success('Uploaded');
    }, (err)=> {
      this.uploading = false;
      let n = new Notify();
      n.httpErr(err);
      console.error(err);
    });
  }
}
